export default "__VITE_ASSET__7ce86e77__"